/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignsUpdate } from '../../axios/campaignsUpdate'
import type {
	CampaignsUpdateError,
	CampaignsUpdatePathParams,
	CampaignsUpdateRequest,
	CampaignsUpdateResponse,
} from '../../types/CampaignsUpdate'

export const campaignsUpdateMutationKey = () => [{ url: '/campaigns/:campaign' }] as const

export type CampaignsUpdateMutationKey = ReturnType<typeof campaignsUpdateMutationKey>

export type CampaignsUpdateVariables = {
	campaign: CampaignsUpdatePathParams['campaign']
	data: CampaignsUpdateRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::update */
export function useCampaignsUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignsUpdateResponse,
		AxiosError<CampaignsUpdateError>,
		CampaignsUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignsUpdateMutationKey(),
		mutationFn: ({ campaign, data }: CampaignsUpdateVariables) =>
			campaignsUpdate(campaign, data, config).then(res => res.data),
		...options,
	})
}
